module.exports = __webpack_public_path__ + "assets/img/page_6.b80a9225.png";